import { useState } from "react";

export default function useUserMode() {
    const getUserMode = () => {
        const userModeString = localStorage.getItem('usermode');
        const user = JSON.parse(userModeString);
        return user?.mode
    };

    const [userMode, setUserMode] = useState(getUserMode());

    const saveUserMode = userMode => {
        localStorage.setItem('usermode', `{"mode":"${userMode}"}`);
        setUserMode(userMode);
    };

    return {
        setLogedUserMode: saveUserMode,
        userMode
    }
}